import type { QueryClient } from '@tanstack/react-query';

/**
 * O Secretário acabou de consultar ou mudar algo (lembrete criado, conta
 * anotada, lembrança guardada): os painéis do palco buscam de novo, para
 * mostrar o dado certo.
 */
export function refreshStageData(queryClient: QueryClient): void {
  for (const queryKey of [
    ['stage-agenda'],
    ['stage-bills'],
    ['deliveries'],
    ['approvals'],
    ['today'],
    ['owner-facts'],
    ['journey'],
    ['trail'],
    ['objectives'],
  ]) {
    void queryClient.invalidateQueries({ queryKey });
  }
}
